import { cn } from '#app/utils/misc.js';

export function Box({ children, className }: { children: React.ReactNode; className?: string }) {
  return <main className={cn('rounded-lg bg-user-nav-light-blue p-4 shadow-sm md:p-8', className)}>{children}</main>;
}
